import { render, staticRenderFns } from "./DailyOverviewItem.vue?vue&type=template&id=0edb2a07&"
import script from "./DailyOverviewItem.vue?vue&type=script&lang=js&"
export * from "./DailyOverviewItem.vue?vue&type=script&lang=js&"
import style0 from "./DailyOverviewItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports